import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { RequestService, LayoutUtilsService, LoaderService } from "src/app/shared";
import { openCenteredPopup } from "src/app/shared/helpers";

interface DialogData {
    docId: string;
    name: string;
    type: string;
    url: string;
    createdAt: string;
    createdName: string;
    caseId: string;
}

@Component({
    selector: 'app-documents-detailed-dialog',
    templateUrl: './document-detailed-dialog.component.html',
    styleUrls: ['./document-detailed-dialog.component.scss']
})
export class DocumentDetailedDialogComponent implements OnInit, OnDestroy {

    public extension: string = undefined;

    constructor(public dialogRef: MatDialogRef<DocumentDetailedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData, private requestService: RequestService, private translate: TranslateService, private layoutUtilsService: LayoutUtilsService, private loader: LoaderService, private _sanitizer: DomSanitizer) { }

    ngOnInit(): void {
        if (this.data.url) {
            this.extension = this.data.url.slice(-4);
        }
    }

    ngOnDestroy(): void {

    }
    openNewTab(data) {
        if (data && data.docId) {
            if (data && data.type && data.type == 'file') {
                let url = '/file/' + data.docId;
                // window.open(url);
                openCenteredPopup('/file/' + data.docId, this.translate.instant('File'));
            } else if (data && data.type && data.type == 'image') {
                let url = '/image/' + data.docId;
                // window.open(url);
                openCenteredPopup(url, this.translate.instant('File'));
            } else {
                // do nothing
            }
        }

    }
}